import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { libraryData } from '@blade-sxp/task-management/components/library-type/library';
let default_1 = class default_1 extends Vue {
    multiple;
    collapseTags;
    libraryOption;
    placeholder;
    clearable;
    libraryId;
    disabled;
    required;
    portartOption = [];
    ruleForm = {
        libraryValue: this.$props.libraryId,
    };
    get cascaderProp() {
        return {
            multiple: this.multiple,
            label: 'label',
            value: 'value',
            emitPath: false,
        };
    }
    get rules() {
        return {
            libraryValue: [{ required: this.required, message: `${this.placeholder}`, trigger: 'change' }],
        };
    }
    libraryOptionChange(val) {
        if (val.type) {
            this.portartOption = libraryData(val.type);
        }
    }
    isValidate() {
        let isValidate = null;
        this.$refs.ruleForm.validate((valid) => {
            if (valid) {
                isValidate = true;
            }
            else {
                isValidate = false;
            }
        });
        return isValidate;
    }
    changeValue(val) {
        this.$emit('update:libraryId', val);
    }
};
__decorate([
    Prop({ default: true, type: Boolean })
], default_1.prototype, "multiple", void 0);
__decorate([
    Prop({ default: true, type: Boolean })
], default_1.prototype, "collapseTags", void 0);
__decorate([
    Prop({ default: () => { }, type: Object })
], default_1.prototype, "libraryOption", void 0);
__decorate([
    Prop({ default: 'Please select', type: String })
], default_1.prototype, "placeholder", void 0);
__decorate([
    Prop({ default: true, type: Boolean })
], default_1.prototype, "clearable", void 0);
__decorate([
    Prop()
], default_1.prototype, "libraryId", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "disabled", void 0);
__decorate([
    Prop({ default: true, type: Boolean })
], default_1.prototype, "required", void 0);
__decorate([
    Watch('libraryOption', { immediate: true })
], default_1.prototype, "libraryOptionChange", null);
default_1 = __decorate([
    Component({
        name: 'LibraryOptional',
        components: {},
        i18n: {
            messages: {
                zh: {},
                en: {},
            },
        },
    })
], default_1);
export default default_1;
